export default __webpack_public_path__ + "static/E-caa3c1f1550f0db24c8f39789bdd39a3.jpg";